import React from 'react';
import Navigation from '@/components/landing/Navigation';
import HeroPremium from '@/components/landing/HeroPremium';
import SelectedWork from '@/components/landing/SelectedWork';
import HowItWorks from '@/components/landing/HowItWorks';
import GettingFound from '@/components/landing/GettingFound';
import FAQPremium from '@/components/landing/FAQPremium';
import FinalCTAPremium from '@/components/landing/FinalCTAPremium';
import SEOContent from '@/components/landing/SEOContent';
import Footer from '@/components/landing/Footer';
import StickyCTA from '@/components/landing/StickyCTA';

/**
 * One ask, in as few words as it takes:
 *   examples → send us the site → or just get found → questions → start.
 *
 * Kept deliberately short. The redesign is the offer: you send us a website, we
 * send back a redesign of it. The hero, the work and the ask all say only that,
 * and nothing is allowed in front of them.
 *
 * `GettingFound` runs after the ask, never before it. Getting found is the
 * third thing we do and the one people can buy on its own, so it has to be
 * visible here, but it is a second door rather than a competing offer. The full
 * argument and the sourced numbers stay at /the-new-era-of-search.
 *
 * The client experience layer is still not on this page. It is a real service
 * but almost nobody arrives wanting it, and naming it here split the message.
 * It has its own page, reached from the navigation and the footer.
 *
 * `SEOContent` stays complete and describes all three. It is visually hidden
 * and exists for crawlers, so trimming the visible page costs the site nothing
 * to be cited on.
 */
export default function Home() {
  return (
    <main className="al-marketing min-h-screen bg-[#F5F3EF] text-[#0A1A2F] overflow-x-clip" role="main">
      <Navigation overDark />
      <HeroPremium />
      <SelectedWork />
      <HowItWorks />
      <GettingFound />
      <FAQPremium />
      <FinalCTAPremium />
      <SEOContent />
      <Footer />
      <StickyCTA />
    </main>
  );
}
